import ReactComponent from '../app/ReactComponent'
import {Button, Col, DatePicker, Form, Input, Result, Row, Space, Spin, Switch} from 'antd'
import {Link} from 'react-router-dom'
import React, {createRef} from 'react'
import {LeftOutlined} from '@ant-design/icons'
import {isEmail, passwordCheck, sleep} from "../helpers/utils"
import {$app} from '../app'
import FloatLabel from '../components/inputs/FloatLabel'
import {CUSTOMER_SOURCE_ID} from '../helpers/misc'

export default class RegistrationPage extends ReactComponent {
  formRef = createRef()
  state = {
    loading_form: false,
    complete: false,
    input_email_value: '',
    input_firstname_value: '',
    input_lastname_value: '',
    input_phone_value: '',
    input_birthdate_value: '',
    input_password_value: '',
    password_valid: false,
  }

  componentDidMount() {

    this.pushPageAnalytics('Registrace účtu - Lobsterka')

  }

  async handleRegistrationForm(data) {
    console.log(data)

    void this.updateState({loading_form: true})

    try {

      const email = this.state.input_email_value
      const firstname = this.state.input_firstname_value
      const lastname = this.state.input_lastname_value
      const phone = this.state.input_phone_value
      const birthdate = this.state.input_birthdate_value
      const agreement_gtc = data.agreement_gtc
      const password = this.state.input_password_value

      if(email === '') throw 'E-mail je pro registraci povinný.'
      if(!isEmail(email)) throw 'Neplatný e-mail.'
      if(!passwordCheck(password)) throw 'Heslo neodpovídá požadavkům.'
      if(agreement_gtc !== true) throw 'Souhlas je pro registraci povinný.'


      await this.$api({
        action: 'carecloud_api',
        route: 'customers',
        method: 'POST',
        data: {
          customer_source: {
            customer_source_id: CUSTOMER_SOURCE_ID
          },
          customer: {
            personal_information: {
              language_id: 'cs',
              first_name: firstname,
              last_name: lastname,
              phone: phone,
              email: email,
              agreement: {
                agreement_gtc: 1,
                agreement_profiling: 1,
                agreement_marketing_communication: 1
              }
            }
          },
          password: password,
          autologin: true
        }
      })

      void this.updateState({
        complete: true,
        loading: false
      })

      await this.props.$auth.sync()
      await this.props.$auth.touch()

      await sleep(2000)

      this.props.navigate('/')

    } catch (error) {

      $app.handleError(error)
      console.error(error)

    } finally {

      void this.updateState({loading_form: false})

    }

  }

  handlePasswordCheck(password_value) {
    const password_valid = passwordCheck(password_value)

    void this.updateState({password_valid: password_valid})
  }

  render() {
    return (
      <>
        <Space style={{marginTop: 20}} size={[18, 20]} direction="vertical" className="ml-2">
          <Link to="/">
            <Button type="text" className="btn-cancel" icon={<LeftOutlined style={{marginTop: '2px'}}/>}>Zpět na přihlášení</Button>
          </Link>
        </Space>
        <section className="container full-height centered lost-password">

          <br/>

          <Row align="center" justify="center" gutter={[20, 20]}>
            <Col span={24}>
              <Spin spinning={this.state.loading_form} size={'large'}>


                <h1 className="h3 card-title">Registrace</h1>
                <p className="card-text">Vytvořte si nový účet.</p>

                {this.state.complete &&
                  <Result
                    status="success"
                    title="Účet vytvořen"
                    subTitle="Vítejte!"
                    extra={
                      <Link to="/">
                        <Button type="primary" className="btn btn-primary">Domů</Button>
                      </Link>
                    }/>
                }

                {!this.state.complete &&
                  <Form
                    ref={this.formRef}
                    layout="vertical"
                    className="mt-4"
                    onFinish={(...args) => this.handleRegistrationForm(...args)}
                    autocomplete="off"
                  >

                    <Form.Item rules={[{
                      required: true, message: 'Vyplňte prosím e-mail.'
                    }]}>
                      <FloatLabel label="E-mailová adresa" value={this.state.input_email_value}>
                        <Input
                          size="large"
                          variant="underlined"
                          value={this.state.input_email_value} onChange={(e) => {
                          void this.updateState({input_email_value: e.target.value})
                        }}
                        />
                      </FloatLabel>

                    </Form.Item>

                    <Form.Item rules={[{
                      required: true, message: 'Vyplňte prosím heslo.'
                    }]}>
                      <FloatLabel label="Heslo" value={this.state.input_password_value}>
                        <Input.Password
                          size="large"
                          variant="underlined"
                          className={`${this.state.password_valid ? 'status-success' : ''}`}
                          value={this.state.input_password_value} onChange={async (e) => {
                          await this.updateState({input_password_value: e.target.value})
                          this.handlePasswordCheck(this.state.input_password_value)
                        }}
                        />
                      </FloatLabel>
                      <p className="_grey-primary-text fs-small pt-1">Heslo musí mít minimálně 8 znaků, jedno velké písmeno a jednu číslici.</p>
                    </Form.Item>

                    <br/>

                    <Form.Item rules={[{
                      required: true, message: 'Vyplňte prosím jméno.'
                    }]}>
                      <FloatLabel label="Jméno" value={this.state.input_firstname_value}>
                        <Input
                          size="large"
                          variant="underlined"
                          value={this.state.input_firstname_value} onChange={(e) => {
                          void this.updateState({input_firstname_value: e.target.value})
                        }}
                        />
                      </FloatLabel>

                    </Form.Item>

                    <Form.Item rules={[{
                      required: true, message: 'Vyplňte prosím přijmení.'
                    }]}>
                      <FloatLabel label="Přijmení" value={this.state.input_lastname_value}>
                        <Input
                          size="large"
                          variant="underlined"
                          value={this.state.input_lastname_value} onChange={(e) => {
                          void this.updateState({input_lastname_value: e.target.value})
                        }}
                        />
                      </FloatLabel>

                    </Form.Item>

                    <Form.Item rules={[{
                      required: true, message: 'Vyplňte prosím telefonní číslo.'
                    }]}>
                      <FloatLabel label="Telefonní číslo" value={this.state.input_phone_value}>
                        <Input
                          size="large"
                          variant="underlined"
                          value={this.state.input_phone_value} onChange={(e) => {
                          void this.updateState({input_phone_value: e.target.value})
                        }}
                        />
                      </FloatLabel>

                    </Form.Item>

                    <Form.Item
                      rules={[{
                        required: true, message: 'Vyplňte prosím datum narození.'
                      }]}>
                      <FloatLabel label="Datum narození" value={'true'}>
                        <DatePicker
                          size="large"
                          format={{
                            format: 'DD.MM.YYYY'
                          }}
                          variant="underlined"
                          value={this.state.input_birthdate_value} onChange={(e) => {
                          void this.updateState({input_birthdate_value: e})
                        }}
                        />
                      </FloatLabel>

                    </Form.Item>


                    <Form.Item
                      className="consent"
                      rules={[{
                        required: true, message: 'Souhlas je pro registraci povinný.'
                      }]}
                    >
                      <Form.Item
                        name="agreement_gtc"
                      >
                        <Switch id="agreement_gtc"/>
                      </Form.Item>
                      <label htmlFor="agreement_gtc">Souhlasím se zpracováním svých osobních údajů za účelem zpracování osobních údajů.</label>
                    </Form.Item>


                    <Space style={{marginTop: 20}} size={[18, 20]} direction="vertical" className="container full ta-center">
                      <Button
                        htmlType="submit"
                        type="primary"
                        className="btn btn-primary">Registrovat</Button>
                    </Space>
                  </Form>
                }
              </Spin>
            </Col>
          </Row>
        </section>
      </>
    )
  }
}